import {
  AUTH_ERROR,
  AUTH_FETCHING_DATA,
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_REFRESH,
} from "../../typesAction";

const INITIAL_STATE = {
  authenticated: null,
  refreshToken: null,
  errorMessage: null,
  isAuth: false,
  inProgress: false,
};

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case AUTH_LOGIN:
      return {
        ...state,
        authenticated: action.payload.token,
        refreshToken: action.payload.refresh_token,
        errorMessage: null,
        isAuth: true,
        inProgress: false,
      };
    case AUTH_REFRESH:
      return {
        ...state,
        authenticated: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        isAuth: true,
      };
    case AUTH_LOGOUT:
      return {
        ...state,
        authenticated: action.payload,
        refreshToken: action.payload,
        errorMessage: null,
        isAuth: false,
        inProgress: false,
      };
    case AUTH_ERROR:
      return { ...state, errorMessage: action.payload, inProgress: false };
    case AUTH_FETCHING_DATA:
      return { ...state, inProgress: action.payload, errorMessage: null };
    default:
      return state;
  }
}
